import {captureMessage} from '@sentry/browser';

import {type ApiErrorClassification, getNumericApiErrorStatus} from './getApiErrorOrigin';

const AMBIGUOUS_CLASSIFICATION_MESSAGE = 'AI assistant error prompt: ambiguous 4xx classification';
const CAPTURED_AMBIGUOUS_STATUSES = new Set<number>();
const IS_DEV = process.env.ENV_TYPE === 'dev';

export const captureAmbiguousApiError = (
  error: unknown,
  classification: ApiErrorClassification
): void => {
  const status = getNumericApiErrorStatus(error);

  if (
    classification.isAmbiguous &&
    !IS_DEV &&
    typeof status === 'number' &&
    !CAPTURED_AMBIGUOUS_STATUSES.has(status)
  ) {
    CAPTURED_AMBIGUOUS_STATUSES.add(status);
    captureMessage(AMBIGUOUS_CLASSIFICATION_MESSAGE, (scope) =>
      scope.setLevel('info').setExtra('status', status)
    );
  }
};
